import { render, staticRenderFns } from "./WhatsNewView.vue?vue&type=template&id=846fc366&scoped=true"
import script from "./WhatsNewView.vue?vue&type=script&lang=js"
export * from "./WhatsNewView.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewView.vue?vue&type=style&index=0&id=846fc366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846fc366",
  null
  
)

export default component.exports